import React, {FC} from "react";
import {Box, CircularProgress, circularProgressClasses} from "@mui/material";

export interface ILoadingSpinnerProps {
  color?: string;
  size?: number;
}

export const LoadingSpinner: FC<ILoadingSpinnerProps> = ({
  color,
  ...props
}) => (
  <Box sx={{ position: 'relative' }}>
    <CircularProgress
      variant="determinate"
      sx={{
        color: (theme) =>
          theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
      }}
      size={40}
      thickness={4}
      {...props}
      value={100}
    />
    <CircularProgress
      variant="indeterminate"
      disableShrink
      sx={{
        color: color || '#0B1C34',
        animationDuration: '550ms',
        position: 'absolute',
        left: 0,
        [`& .${circularProgressClasses.circle}`]: {
          strokeLinecap: 'round',
        },
      }}
      size={40}
      thickness={4}
      {...props}
    />
  </Box>
);
